module.exports = __webpack_public_path__ + "images/application/illustrations/pipes-sidebar-1319c664.svg";